import { render, staticRenderFns } from "./component-games-list-featured.vue?vue&type=template&id=f2cd3114&scoped=true"
import script from "./component-games-list-featured.vue?vue&type=script&lang=js"
export * from "./component-games-list-featured.vue?vue&type=script&lang=js"
import style0 from "./component-games-list-featured.vue?vue&type=style&index=0&id=f2cd3114&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2cd3114",
  null
  
)

export default component.exports